import React from 'react';
import { context } from './error-boundary';

export function useCatchError() {
  const boundaryPresent = React.useContext(context);
  const [error, setError] = React.useState<Error>();
  // I need this to be stable across renders for when it's used in useEffect.
  const impl = React.useRef(
    async <T extends unknown>(p: Promise<T>): Promise<T> => {
      try {
        return await p;
      } catch (error) {
        setError(error);
        throw error;
      }
    },
  );

  if (!boundaryPresent) {
    throw new Error('useCatchContext must be used inside the ErrorBoundary');
  }

  if (error) {
    throw error;
  }


  return impl.current;
}
